import React from 'react';

const TermsContent: React.FC = () => {
  return (
    <div className="max-w-none text-gray-800 space-y-8 py-2">
      <section>
        <h3 className="text-lg font-extrabold text-white mb-2 uppercase tracking-tight">
          LEGAL NOTICE
        </h3>
        <p className="text-[15px] leading-relaxed text-gray-700">
          PRAIRI matches and notifies users based solely on the information that they (the Users)
          have provided and are not responsible for its accuracy nor are we recommending that the
          investor invest in any of the startups on our platform nor are we recommending that any of
          the startups do business with (or receive investment from) any of the investors on our
          platform. PRAIRI is merely informing its users that another member has matching criteria.
          PRAIRI is not legally responsible if our users wish to do business together.
        </p>
      </section>

      <section>
        <h3 className="text-lg font-extrabold text-gray-900 mb-2 tracking-tight">Who We Are</h3>
        <p className="text-[15px] leading-relaxed text-gray-700">
          PRAIRI (&quot;We&quot;, &quot;Us&quot; and &quot;Our&quot;) operates the website
          prairi.com (&quot;Website&quot;) and platform (collectively the &quot;Service&quot;).
        </p>
      </section>

      <section>
        <h3 className="text-lg font-extrabold text-gray-900 mb-2 tracking-tight">What We Do</h3>
        <p className="text-[15px] leading-relaxed text-gray-700">
          The Service provides a platform for startup business founders and business investors to
          meet. Lifetime Access strictly refers to our service of matching startups with investors,
          at the time(s) startups are seeking funding. Future services may be offered at an
          additional cost, should you choose to use them. How many matches you receive depends on
          your criteria.
        </p>
      </section>

      <section>
        <h3 className="text-lg font-extrabold text-gray-900 mb-2 tracking-tight">Revenue Model</h3>
        <p className="text-[15px] leading-relaxed text-gray-700">
          We reserve the right to make changes to our business/revenue model at any time. If an
          Investor decides to do business with a company with whom we&apos;ve made an introduction,
          the Investor will pay a &apos;success fee&apos; (currently 2%) based on the total amount
          of investment to be received by the startup. This fee is only charged with whom and where
          it is legally allowed, based on each country&apos;s regulations.
        </p>
      </section>

      <section>
        <h3 className="text-lg font-extrabold text-gray-900 mb-2 tracking-tight">
          Terms of Service
        </h3>
        <div className="space-y-4 text-[15px] leading-relaxed text-gray-700">
          <p>
            We provide the user of the Service (&quot;You&quot; and &quot;Your&quot;) with access to
            the Service on and subject to the following Terms of Service (&quot;ToS&quot;), which
            may be updated by Us at any time without notice to You. You should read these ToS
            carefully before using any part of the Service. The most current version of the ToS at
            any time can be found by accessing the &quot;Terms of Service&quot; link on Our Website.
          </p>
          <p>
            Please check the ToS every time You wish to use the Service to ensure You understand the
            terms that apply at that time. You are also responsible for ensuring that all persons
            who access the Service through Your User account on the Service are aware of these ToS
            and that they comply with them.
          </p>
          <p>
            If You do not agree to the ToS You should immediately exit Our Website and cease to use
            the Service. If You are a registered user of Service, You will be required to delete
            Your profile.
          </p>
        </div>
      </section>

      <section>
        <h3 className="text-lg font-extrabold text-gray-900 mb-2 tracking-tight">
          Communication Between You and Us
        </h3>
        <p className="text-[15px] leading-relaxed text-gray-700">
          The easiest way to communicate with Us is to email Us at info@prairi.com. If We have to
          contact You We will do so by writing to You at the email address You provided to Us in the
          Registration Data referred to below. When We refer in the ToS to &quot;in writing&quot; or
          &quot;written&quot;, this will include e-mail.
        </p>
      </section>

      <section>
        <h3 className="text-lg font-extrabold text-gray-900 mb-2 tracking-tight">
          Account Registration
        </h3>
        <p className="text-[15px] leading-relaxed text-gray-700">
          You will provide true, accurate, current and complete information about You as prompted by
          the Service account registration form on the Website (such information being the
          &quot;Registration Data&quot;); and maintain and promptly update the Registration Data to
          keep it true, accurate and complete. If You provide any Registration Data or other
          information that is untrue, inaccurate or incomplete or We have reasonable grounds to
          suspect that such information is untrue, inaccurate or incomplete, We may suspend or
          terminate Your account and refuse any and all current or future use of the Service (or any
          part thereof).
        </p>
      </section>

      <section>
        <h3 className="text-lg font-extrabold text-gray-900 mb-2 tracking-tight">
          Account Security
        </h3>
        <p className="text-[15px] leading-relaxed text-gray-700">
          You are responsible for maintaining the confidentiality of Your account and password. You
          must immediately notify Us of any unauthorised use of Your password or account or any
          other breach of security. We do not accept any liability for any loss or damage arising
          from Your failure to comply with this responsiblity.
        </p>
      </section>

      <section>
        <h3 className="text-lg font-extrabold text-gray-900 mb-2 tracking-tight">
          Your Use of The Service
        </h3>
        <div className="space-y-4 text-[15px] leading-relaxed text-gray-700">
          <p>
            You understand and agree that all information, data, text, software, sound, photographs,
            graphics, video, messages or other materials (&quot;Content&quot;), whether publicly
            posted or privately transmitted, is the sole responsibility of the person from which
            such Content originated. You acknowledge that We do not control and may not pre-screen
            the Content posted by users of the Service (including You) and therefore We cannot (and
            do not) guarantee the accuracy, integrity or quality of such Content.
          </p>
          <p>
            You are solely responsible for all Content that You upload, transmit or otherwise make
            available via the Service. You agree to comply with all applicable laws regarding the
            transmission of data from the country in which You reside.
          </p>
          <p>
            You agree not to use the Service to upload, post, email, transmit or otherwise make
            available any Content that:
          </p>
          <ul className="list-disc pl-5 space-y-2">
            <li>
              Is unlawful, harmful, threatening, abusive, harassing, tortious, defamatory, vulgar,
              obscene, libellous, deceptive, fraudulent, invasive of another&apos;s privacy,
              sexually explicit or pornographic, hateful, or racially, ethnically or otherwise
              objectionable;
            </li>
            <li>
              amounts to personal attacks on others or make disparaging remarks about any person or
              entity and/or stalk or otherwise harass others;
            </li>
            <li>interferes with anyone else&apos;s use and enjoyment of the Service;</li>
            <li>
              encourages, incites, solicits or promotes illegal or criminal activities (including
              market manipulation, pornography, terrorism, explosives, weapons, drugs, programming
              viruses, computer hacking and copyright infringement)
            </li>
            <li>abuses, threatens, promotes, or instigates physical harm or death;</li>
            <li>
              infringes any patent, trademark, trade secret, copyright or other proprietary rights
              of any party;
            </li>
            <li>
              contains software viruses or any other computer code, files or programs designed to
              interrupt, destroy or limit the functionality of any computer software or hardware or
              telecommunications equipment or to damage or obtain unauthorised access to any data or
              other information of any third party;
            </li>
            <li>impersonates any person or entity;</li>
            <li>has had identifiers manipulated in order to disguise its origin;</li>
          </ul>
          <p>You agree not to:</p>
          <ul className="list-disc pl-5 space-y-2">
            <li>
              use the Service to upload, post, email, transmit or otherwise make available any
              unsolicited or unauthorised advertising, promotional materials, &quot;junk mail&quot;
              or &quot;spam&quot;;
            </li>
            <li>
              interfere with or disrupt the Service or servers or networks connected to the Service;
            </li>
            <li>use the Service to stalk or otherwise harass other users; or</li>
            <li>use the Service to collect or store personal data about other users.</li>
          </ul>
          <p>
            We may remove any Content which violates the ToS or which We deem to be offensive,
            indecent or objectionable. Furthermore, We may retain and disclose Content if required
            to do so by law or in the good faith belief that such retention or disclosure is
            reasonably necessary to:
          </p>
          <ul className="list-disc pl-5 space-y-2">
            <li>comply with any legal process;</li>
            <li>enforce the ToS;</li>
            <li>respond to claims that any Content violates the rights of third-parties; or</li>
            <li>
              protect the rights, property, or personal safety of Us, Our other users or the public.
            </li>
          </ul>
          <p>
            We do not guarantee that the Service or any Content will always be available. We may
            suspend, withdraw or restrict the availability of all or any part of the Service and/or
            Content for business and/or operational reasons. We will try to give You reasonable
            notice of any suspension or withdrawal but may do so without notice.
          </p>
        </div>
      </section>

      <section>
        <h3 className="text-lg font-extrabold text-gray-900 mb-2 tracking-tight">
          Viruses and Bugs
        </h3>
        <div className="space-y-4 text-[15px] leading-relaxed text-gray-700">
          <p>
            We do not guarantee that the Service will be secure or free from bugs or viruses. You
            are responsible for configuring and protecting Your information technology, computer
            programmes and platform to access the Service. You should use Your own virus protection
            software.
          </p>
          <p>
            You agree to not misuse the Service by knowingly introducing viruses, trojans, worms,
            logic bombs or other material that is malicious or technologically harmful. You must not
            attempt to gain unauthorised access to the Service, the server on which any part of the
            Service is stored or any server, computer or database connected to the Service. You must
            not attack any part of the Service via a denial-of-service attack. By breaching this
            section, Your right to use the Service will cease immediately and You would commit a
            criminal offence. We will be entitled to report any such breach to the relevant law
            enforcement authorities and may co-operate with those authorities by disclosing Your
            identity to them.
          </p>
        </div>
      </section>

      <section>
        <h3 className="text-lg font-extrabold text-gray-900 mb-2 tracking-tight">
          Our Copyrights, Trademarks and other Proprietary Rights
        </h3>
        <div className="space-y-4 text-[15px] leading-relaxed text-gray-700">
          <p>
            Our trademarks, service marks and logos are registered and unregistered trade marks (the
            &quot;Trade Marks&quot;). Your use of the Service does not grant You a license or right
            to use Our Trade Marks.
          </p>
          <p>
            You acknowledge and agree that the Service and any necessary software used in connection
            with the Service (&quot;Software&quot;) contains proprietary and confidential
            information that is protected by applicable intellectual property and other laws. You
            agree not to modify the Software in any manner or form, or to use modified versions of
            the Software. You further acknowledge and agree that Content contained in information
            presented to You through the Service or by Our partners is protected by copyrights,
            trademarks, service marks, patents or other proprietary rights and laws.
          </p>
          <p>
            Except as expressly authorised by Us (or Our partners in the case of their Content), You
            agree not to copy, reproduce, modify, distribute, transmit, publish, license, use,
            resell, rent, lease, loan, all or any part of the Service, the Software or Content
            contained in information presented to You through the Service, or create derivative
            works based on any of the same, in whole or in part.
          </p>
          <p>
            We grant You a personal, non-transferable, revocable and non-exclusive right and license
            to:
          </p>
          <ul className="list-decimal pl-5 space-y-2">
            <li>Use the Service, provided that such use is in accordance with these ToS;</li>
            <li>
              print or download extracts of information obtained by You through the Service for Your
              personal non-commercial use;
            </li>
            <li>
              copy information obtained by You through the Service for the purpose of sending to
              individual third parties for their personal non-commercial information, provided that
              You acknowledge Us as the source of the information and that You ensure that the third
              parties comply with these conditions as if they were a party to them; and
            </li>
            <li>
              use Our API to access and extract into Your own systems the relevant data that We from
              time to time make available for such purpose (&quot;Extraction Data&quot;), and the
              right to use the Extraction Data for commercial and/or non-commercial purposes,
              provided that in each case, You agree not to access the Service or otherwise try to
              extract the Extraction Data, by any means other than through the interfaces that are
              provided by Us.
            </li>
          </ul>
        </div>
      </section>

      <section>
        <h3 className="text-lg font-extrabold text-gray-900 mb-2 tracking-tight">
          Your Copyrights and Content
        </h3>
        <div className="space-y-4 text-[15px] leading-relaxed text-gray-700">
          <p>
            We do not own nor claim claim ownership of Content You submit to or make available for
            inclusion on the Service. With respect to Content You submit to or make available for
            inclusion on, the Service, via areas of the Service that are:
          </p>
          <p>
            Publicly accessible, You grant Us, a worldwide, royalty-free, non-exclusive, perpetual,
            irrevocable and fully sub-licensable license to use, distribute, reproduce, modify,
            adapt, publish, translate and display such Content (in whole or in part) and to
            incorporate such Content into other works in any format or medium now known or later
            developed; and non-publicly accessible, You grant Us, a worldwide, royalty-free,
            non-exclusive, irrevocable license to use, distribute, reproduce, modify, adapt,
            publish, translate and display such Content (in whole or in part) on the Service, solely
            for the purpose for which such Content was submitted or made available. This license
            remains in effect for as long as You choose to continue to include such Content on the
            Service and will terminate when You remove or We remove such Content from the Service.
            For the purpose of this section, &apos;publicly accessible&apos; areas of the Service
            are those areas that are intended by Us to be available to the general public. Publicly
            accessible areas of the Service would not include portions of the Service intended for
            private communication.
          </p>
        </div>
      </section>

      <section>
        <h3 className="text-lg font-extrabold text-gray-900 mb-2 tracking-tight">
          Linking to Our Service
        </h3>
        <div className="space-y-4 text-[15px] leading-relaxed text-gray-700">
          <p>
            You may link to Our Website, provided You do so in a way that is fair and legal and does
            not damage Our reputation. You must not establish a link in such a way as to suggest any
            form of association with, approval of, or endorsement by Us where none exists. You must
            not establish a link to Our Website in any website that is not owned by You. Our Website
            must not be framed on any other website. We reserve the right to withdraw linking
            permission at any time. If You wish to link or make use of Content on Our Website other
            than that set out in this section, please email us at info@prairi.com
          </p>
          <p>
            The Service may provide, or third parties may provide, links to other World Wide Web
            sites or resources. These links are provided for Your information only. Such links
            should not be interpreted as approval by Us of those links or information You may obtain
            from them. We have no control over the contents of those websites or resources and are
            not responsible for the availability of such sites or resources, and do not endorse any
            Content, advertising, products, or other materials on or available from such sites or
            resources. We accept no responsibility or liability, directly or indirectly, for damage
            or loss caused or alleged to be caused by or in connection with use of or reliance on,
            any such any information or Content contained in any such site or resource.
          </p>
        </div>
      </section>

      <section>
        <h3 className="text-lg font-extrabold text-gray-900 mb-2 tracking-tight">
          Protecting Your Data
        </h3>
        <div className="space-y-4 text-[15px] leading-relaxed text-gray-700">
          <p>
            For the purposes of this section, the terms &quot;personal data&quot;,
            &quot;controller&quot;, and &quot;processing&quot;, will have the meanings set out under
            applicable Data Protection Laws. Data Protection Laws means EU Directive 95/46/EC as
            amended, replaced or superseded from time to time, including, from 25 May 2018, EU
            General Data Protection Regulation 2016/679 and, to the extent applicable, the data
            protection or privacy laws of any other country.
          </p>
          <p>
            Our Privacy Policy sets out the terms on which We process any personal data We collect
            from You or that You provide to Us.
          </p>
          <p>
            Where You copy material from the Website or Our other Service for Your own use, to the
            extent that such material includes personal data, You acknowledge and agree that You
            will act as controller in relation to the personal data which You process and You agree
            to comply with all applicable Data Protection Laws.
          </p>
          <p>
            Other users or third parties may, consistent with Your preferences and the information
            You provide, process, access and/or share Your information (including any personal
            data). To the extent that a third party makes such use of Your personal data, You
            acknowledge and agree that they will do so as controller and We will have no control
            over their processing of Your personal data.
          </p>
        </div>
      </section>

      <section>
        <h3 className="text-lg font-extrabold text-gray-900 mb-2 tracking-tight">
          Cookies and Analytics
        </h3>
        <p className="text-[15px] leading-relaxed text-gray-700">
          We use Firebase Analytics, a web analytics service provided by Google, to collect and
          analyze non-personal and aggregated data about your use of the Website. Firebase Analytics
          may use cookies and similar technologies to track user interactions. By using the Website,
          you consent to the use of cookies for analytics purposes. To learn more about how Firebase
          Analytics collects and processes data, please review Google&apos;s Privacy Policy.
        </p>
      </section>

      <section>
        <h3 className="text-lg font-extrabold text-gray-900 mb-2 tracking-tight">
          Terminating Your Use of Our Service
        </h3>
        <p className="text-[15px] leading-relaxed text-gray-700">
          You agree that We, in Our sole discretion, may terminate the password, account (or any
          part thereof) or Your use of the Service, and remove and discard any Content within the
          Service, for any reason. We may also in Our sole discretion and at any time discontinue
          providing the Service (or any part thereof), with or without notice. You agree that any
          termination of Your access to the Service under any provision of this ToS may be effected
          without prior notice, and acknowledge and agree that We may immediately deactivate or
          delete Your account and all related information and files in Your account and/or bar any
          further access to such files or the Service. Further, You agree that We will not be liable
          to You or any third-party for any termination of Your access to the Service.
        </p>
      </section>

      <section>
        <h3 className="text-lg font-extrabold text-gray-900 mb-2 tracking-tight">Disclaimer</h3>
        <div className="space-y-4 text-[15px] leading-relaxed text-gray-700">
          <p>
            We take all reasonable care to ensure that information obtained by You through the
            Service is correct, but We are providing the Service on an &quot;AS IS&quot; basis and
            we make no representation or warranty of any kind regarding the Service or information
            obtained by You through the Service. You should be aware that information obtained by
            You through the Service, may be incomplete, out of date, inaccurate, incorrect or
            unsuitable for any purpose. It is therefore essential that You verify all such
            information or take appropriate professional advice before taking any action in reliance
            upon it.
          </p>
          <p>
            You expressly understand and agree that Your use of the Service is at Your sole risk and
            that the Service is provided on an &quot;AS IS&quot; and &quot;AS AVAILABLE&quot; basis.
            We expressly disclaim all warranties of any kind, whether express or implied. Any
            material downloaded or otherwise obtained through use of the Service is done at the sole
            discretion and risk of You and You will be solely responsible for any damage to its
            computer system or loss of data that results from the download of any such material. No
            advice or information, whether oral or written, obtained by You from Us or through or
            from the Service will create any warranty not expressly stated in these ToS.
          </p>
          <p>
            You understand, acknowledge and agree that the Service is designed as an information and
            networking tool only, and that We are not engaged in providing, nor are We representing
            ourselves as providing legal, tax, financial, accounting, or other professional advice
            or opinions of any nature whatsoever to You.
          </p>
          <p>
            Information obtained by You through the Service is not intended to constitute a
            financial promotion for the purposes of the Financial Services and Markets Act 2000. In
            addition, information obtained by You through the Service does not amount to a
            recommendation or advice by Us, on the merits of any transaction or service. We are
            therefore not responsible for providing You with the protection which would ordinarily
            be afforded to clients by FCA regulated firms and You should seek Your own legal,
            investment and tax advice before acting on information obtained through the Service.
          </p>
          <p>
            You understand, acknowledge and agree that information obtained through the Service is
            for information purposes only and not investment advice and that it is Your own
            responsibility to obtain independent legal, tax, financial, accounting, or other
            professional advice with respect to evaluating, agreeing, establishing and/or
            implementing any relationship or investment based on any of the information obtained via
            the Service.
          </p>
        </div>
      </section>

      <section>
        <h3 className="text-lg font-extrabold text-gray-900 mb-2 tracking-tight">Your Indemnity</h3>
        <p className="text-[15px] leading-relaxed text-gray-700">
          You agree that You are responsible for and will pay to Us, Our officers, directors,
          employees, agents, licensors and suppliers all amounts which cover all losses, expenses,
          damages and costs, including legal fees reasonably incurred, resulting from any violation
          of these ToS or any activity related to Your account (including negligent or wrongful
          conduct), by You or any other person accessing Our Website using Your account.
        </p>
      </section>

      <section>
        <h3 className="text-lg font-extrabold text-gray-900 mb-2 tracking-tight">
          Limitation of Our Liability
        </h3>
        <div className="space-y-4 text-[15px] leading-relaxed text-gray-700">
          <p>
            Your Permitted Use of Our Service is allowed on the condition that you accept and abide
            by these terms
          </p>
          <p>
            We do not exclude or limit in any way our liability to You where it would be unlawful to
            do so. This includes liability for death or personal injury caused by Our negligence or
            the negligence of Our employees, agents or subcontractors and for fraud or fraudulent
            misrepresentation.
          </p>
          <p>
            Subject to this, Our liability to You or any third party, and the liability of our
            affiliates, officers, directors, agents and employees, in any circumstance is limited to
            one hundred euros (100 EUR).
          </p>
          <p>We will not be liable for:</p>
          <ul className="list-disc pl-5 space-y-2">
            <li>loss of profits, sales, business, or revenue;</li>
            <li>business interruption;</li>
            <li>loss of anticipated savings;</li>
            <li>loss of business opportunity, goodwill or reputation; or</li>
            <li>any indirect or consequential loss or damage.</li>
          </ul>
          <p>
            Subject to section 16.2, We exclude all implied conditions, warranties, representations
            or other terms that may apply to the Service (including any Content submitted to or made
            available on, the Service) and we will not be liable to You for any loss or damage,
            whether in contract, tort (including negligence), breach of statutory duty, or
            otherwise, even if foreseeable, arising under or in connection with:
          </p>
          <ul className="list-disc pl-5 space-y-2">
            <li>the use or the inability to use the Service; or</li>
            <li>the use of or reliance on any Content obtained through the Service; or</li>
            <li>
              any agreement, understanding or relationship You enter into with any other person or
              entity with whom You have been put in contact through the Service.
            </li>
          </ul>
          <p>
            Subject to section 16.2, You understand, acknowledge and agree that We do not (in any
            manner whatsoever) endorse other users of the Service or information or pitch decks
            presented to You by such users. We will not be held liable for any claims of any nature
            whatsoever arising or resulting from any information or pitch deck of any of other
            users.
          </p>
          <p>
            The exclusions and restrictions of liability contained in these ToS are considered
            reasonable by You.
          </p>
        </div>
      </section>

      <section>
        <h3 className="text-lg font-extrabold text-gray-900 mb-2 tracking-tight">
          Jurisdictional Exclusions and Limitations
        </h3>
        <p className="text-[15px] leading-relaxed text-gray-700">
          Some jurisdictions do not allow the exclusion of certain warranties or the limitation or
          exclusion of certain liabilities. Accordingly, some of the above limitations of sections
          14 and 16 may not apply to You.
        </p>
      </section>

      <section>
        <h3 className="text-lg font-extrabold text-gray-900 mb-2 tracking-tight">
          Other Relevant Information
        </h3>
        <div className="space-y-4 text-[15px] leading-relaxed text-gray-700">
          <p>
            Each of the provisions contained in these ToS will be construed as being independent of
            every other and if any provision contained in the ToS is determined to be invalid or
            unenforceable pursuant to applicable law, such determination will not affect the
            validity of the remainder of these terms which will continue in effect with the invalid
            provision deemed deleted.
          </p>
          <p>
            The Service is operated and controlled from the EU and these terms and Your use of the
            Service is governed by and construed in accordance with the laws of England and Wales.
          </p>
          <p>
            These ToS (and any documents referred to herein) constitute the entire agreement between
            You and Us and govern the use of the Service by You, superseding any prior agreements
            between You and Us. You also may be subject to additional terms that may apply when You
            use affiliate services, third-party content or third-party software. The failure of Us
            to exercise or enforce any right or provision of the ToS, will not constitute a waiver
            of such right or provision. If any provision of the ToS is found by a court of competent
            jurisdiction to be invalid, the parties nevertheless agree that the court should
            endeavour to give effect to the parties&apos; intentions as reflected in the provision,
            and the other provisions of the ToS remain in full force and effect. The section titles
            in these ToS are for convenience only and have no legal or contractual effect.
          </p>
        </div>
      </section>
    </div>
  );
};

export default TermsContent;
